module.exports = __webpack_public_path__ + "static/media/disable_sample_request.7c164a2e.png";